import { definePlatformSetting } from '@crest/platform-contracts/settings';
import { z } from 'zod';
// Tenant-owned Contact snippet labels use the existing Platform release system.
export const relationshipsContactSnippetCopySchema = z.strictObject({
    snippetInsertAction: z.string().trim().min(1).max(240),
    snippetCloseAction: z.string().trim().min(1).max(240),
    snippetSearchLabel: z.string().trim().min(1).max(240),
    snippetLoadingLabel: z.string().trim().min(1).max(240),
    snippetUnavailableLabel: z.string().trim().min(1).max(240),
    snippetRetryAction: z.string().trim().min(1).max(240),
    snippetEmptyLabel: z.string().trim().min(1).max(240),
    snippetInsertError: z.string().trim().min(1).max(240),
    previousPageAction: z.string().trim().min(1).max(240),
    nextPageAction: z.string().trim().min(1).max(240),
});
export const relationshipsContactSnippetCopySetting = definePlatformSetting({
    definition: {
        key: 'relationships.copy.contact-note-snippets', moduleId: 'relationships',
        title: 'Contact note snippet labels', helpText: 'Labels for optional Contact note template insertion.',
        configurationDomain: 'copy', valueType: 'object', schemaVersion: 1,
        codedFallback: {
            "snippetInsertAction": "Insert snippet",
            "snippetCloseAction": "Close snippets",
            "snippetSearchLabel": "Search note snippets",
            "snippetLoadingLabel": "Loading snippets…",
            "snippetUnavailableLabel": "Snippets are unavailable. You can keep writing and save your note.",
            "snippetRetryAction": "Retry snippets",
            "snippetEmptyLabel": "No matching note snippets.",
            "snippetInsertError": "The snippet would exceed the note limit. Your draft has not changed.",
            "previousPageAction": "Previous snippets",
            "nextPageAction": "Next snippets"
        },
        permittedScopes: ['platform', 'plan', 'tenant'], mergeStrategy: 'deep-merge',
        clientSafe: true, serverOnly: false, sensitive: false, tenantEditable: true,
        userOverridable: false, offlineEligible: true, safetyClass: 'ordinary',
    },
    valueSchema: relationshipsContactSnippetCopySchema,
});
//# sourceMappingURL=relationships-contact-snippet-copy.js.map